// SB-01 (revisão da fase 4) · Mensagem de erro no idioma da tela. A API responde em português; em en e es o texto vem
// do dicionário pelo código do erro (primeiro o namespace do módulo, que conhece o sentido do código naquela tela;
// depois o núcleo) e, sem tradução, de uma frase genérica no idioma certo com o código. Os `details` do erro entram
// como variáveis da tradução (ex.: {{disponivel}}). Nunca mostra português numa tela em inglês ou espanhol.
import i18n from 'i18next';
import { ErroApi } from './api';

const emPortugues = () => !i18n.language || i18n.language === 'pt';

function porCodigo(code: string, modulo?: string, details?: unknown): string | null {
  const vars = details && typeof details === 'object' ? (details as Record<string, unknown>) : {};
  for (const n of [...(modulo ? [modulo] : []), 'nucleo']) {
    const k = `${n}:erros.${code}`;
    if (i18n.exists(k)) return i18n.t(k, vars);
  }
  return null;
}

/** Texto de um erro da API (ou qualquer erro) para mostrar ao usuário no idioma ativo. */
export function textoDoErro(e: unknown, modulo?: string): string {
  if (e instanceof ErroApi) {
    // VB4-02: falha de rede não tem mensagem do servidor; o texto vem do dicionário também em pt.
    if (e.code === 'rede') return i18n.t('nucleo:erros.rede');
    if (emPortugues()) return e.message;
    // Rodada 28: erro de domínio único vem com os details dentro de errors[]; sem eles a interpolação saía vazia.
    const details = e.details ?? e.erros.find((x) => x.code === e.code)?.details;
    return porCodigo(e.code, modulo, details) ?? i18n.t('nucleo:erros.generico', { code: e.code });
  }
  if (emPortugues()) return e instanceof Error ? e.message : String(e);
  // fetch que não chega ao servidor lança TypeError; o resto é falha inesperada da própria tela.
  return i18n.t(e instanceof TypeError ? 'nucleo:erros.rede' : 'nucleo:erros.inesperado');
}

/** Texto de um item de erro (lista `errors` da API) no idioma ativo. */
export function textoDoItem(x: { code: string; message: string; details?: unknown }, modulo?: string): string {
  if (x.code === 'rede') return i18n.t('nucleo:erros.rede');
  if (emPortugues()) return x.message;
  return porCodigo(x.code, modulo, x.details) ?? i18n.t('nucleo:erros.generico', { code: x.code });
}
